import type { StoreGeneric } from "pinia";
import { storeToRefs } from "pinia";
import { useSettingsStore as _useSettingsStore } from "./settings";
import { useEvaluationStore as _useEvaluationStore } from "./evaluation";
import { useScenarioStore as _useScenarioStore } from "./scenario";
import { useSizingStore as _useSizingStore } from "./sizing";
import { useEquipmentStore as _useEquipmentStore } from "./equipment";
import { useEulaStore as _useEulaStore } from "./eula";
import { useDiagnosticsStore as _useDiagnosticsStore } from "./diagnostics";

type UniqueProperties<Type1, Type2> = {
  [K in Exclude<keyof Type1, keyof Type2>]: Type1[K];
} & Type2;

export type StoreWithRefs<T extends StoreGeneric> = UniqueProperties<
  T,
  ReturnType<typeof storeToRefs<T>>
>;

function withRefs<T extends StoreGeneric>(
  use: () => T
): () => StoreWithRefs<T> {
  return () => {
    return {
      ...use(),
      ...storeToRefs(use())
    };
  };
}

export const useSizingStore = withRefs(_useSizingStore);
export const useScenarioStore = withRefs(_useScenarioStore);
export const useEquipmentStore = withRefs(_useEquipmentStore);
export const useEvaluationStore = withRefs(_useEvaluationStore);
export const useSettingsStore = withRefs(_useSettingsStore);
export const useEulaStore = withRefs(_useEulaStore);
export const useDiagnosticsStore = withRefs(_useDiagnosticsStore);
